import React, { Fragment } from "react"
import { Box, Link, Stack, Typography } from "@mui/material"
import {
  AnnouncementLearnMoreEnum,
  AnnouncementTypeEnum
} from "../../../../../mp-utils/generic-utils"
import { Chip, Button, ExperienceRatingScale, TextInput } from "../../"
import { FaIcon } from "../../../../../mp-core/icons"
import {
  AnnouncementsItemType,
  FeedbackSurvey
} from "../../../../../mp-database/contextHelpManager"
import { StylesType } from "../styles"
import { TEACHER_FEEDBACK_ID } from "../../../../../mp-core/components/FeedbackTray/constants"
import { FACE_NAMES_WITH_NULL_VALUE } from "../../ExperienceRatingScale/constants"
import useFeedback from "../hooks/useFeedback"
interface Props {
  data: AnnouncementsItemType[]
  currentPage: number
  classes: StylesType
  onOpenClose: () => void
  isLoadingItem: (id: string) => boolean
  submitCardHandler: (item: AnnouncementsItemType) => void
  onClickCustomButton?: () => void
  learnMoreModalHandler?: (item: AnnouncementsItemType) => void
  onSendFeedbackClick: (fb: FeedbackSurvey) => void
}

const GhostieContent: React.FC<Props> = ({
  data,
  currentPage,
  classes,
  onOpenClose,
  isLoadingItem,
  submitCardHandler,
  onClickCustomButton,
  learnMoreModalHandler,
  onSendFeedbackClick
}) => {
  const {
    feedbackShow,
    feedback,
    setFeedback,
    onFeedbackSmileClick,
    checkFeedbackClose
  } = useFeedback()

  const onCloseGhostieCard = (item: AnnouncementsItemType) => {
    checkFeedbackClose(item)

    if (!!item.allowPermanentDismiss && item.id !== TEACHER_FEEDBACK_ID) {
      submitCardHandler(item)
      return
    }

    onOpenClose()
  }

  return (
    <>
      <Box className={classes.cardColorHead} />
      {data.map(
        (item, index) =>
          currentPage === index + 1 && (
            <Fragment key={item.id}>
              {item.imgFileRef && item.imgFileRef.url && (
                <img
                  alt=""
                  className={classes.image}
                  src={item.imgFileRef.url}
                />
              )}
              <Box className={classes.cardContent}>
                {!["CUSTOM", "GENERAL", "FEEDBACK_REQUEST"].includes(
                  item.type
                ) &&
                  AnnouncementTypeEnum[item.type] && (
                    <Chip
                      size="sm"
                      className={classes.cardTypeChip}
                      label={AnnouncementTypeEnum[item.type]}
                    />
                  )}

                {item.title && (
                  <Typography
                    component="h1"
                    variant="h3"
                    className={classes.cardTitle}
                  >
                    {item.title}
                  </Typography>
                )}

                {item.type === "FEEDBACK_REQUEST" && item.subtitle && (
                  <Box>
                    <Typography
                      component="h1"
                      variant="h4"
                      className={classes.cardTitle}
                    >
                      {item.subtitle}
                    </Typography>
                    <ExperienceRatingScale
                      selectedRate={FACE_NAMES_WITH_NULL_VALUE[feedback.rating]}
                      onChange={e => {
                        onFeedbackSmileClick(e)
                      }}
                      className={classes.ratingScale}
                    />
                  </Box>
                )}

                {(item.type !== "FEEDBACK_REQUEST" || feedbackShow) && (
                  <Typography
                    variant="body2"
                    className={classes.cardDescription}
                  >
                    {item.message}
                  </Typography>
                )}
                {item.type === "FEEDBACK_REQUEST" && feedbackShow && (
                  <TextInput
                    className={classes.feedbackInput}
                    value={feedback.feedback}
                    onChange={e => {
                      setFeedback({ ...feedback, feedback: e.target.value })
                    }}
                  />
                )}

                <Stack
                  direction="row"
                  spacing={2}
                  className={classes.cardActions}
                >
                  <Button
                    size="sm"
                    color="primary"
                    variant="text"
                    startIcon={
                      item?.id &&
                      isLoadingItem?.(item.id) && (
                        <FaIcon spin name="spinner-third" />
                      )
                    }
                    disabled={item?.id && isLoadingItem?.(item.id)}
                    onClick={() => onCloseGhostieCard(item)}
                  >
                    {item.allowPermanentDismiss &&
                    item.id !== TEACHER_FEEDBACK_ID
                      ? "Dismiss"
                      : "Close"}
                  </Button>

                  {item.type === "FEEDBACK_REQUEST" && (
                    <Button
                      size="sm"
                      color="primary"
                      variant="contained"
                      onClick={() => onSendFeedbackClick(feedback)}
                      disabled={feedback.rating <= 0}
                      loading={isLoadingItem?.("feedback_request")}
                    >
                      Send Feedback
                    </Button>
                  )}

                  {item.type === "CUSTOM" && item?.customButtonText && (
                    <Button
                      size="sm"
                      color="primary"
                      variant="contained"
                      onClick={onClickCustomButton}
                    >
                      {item?.customButtonText}
                    </Button>
                  )}

                  {item.learnMoreItem?.type && (
                    <Button
                      size="sm"
                      color="primary"
                      variant="contained"
                      onClick={e => {
                        item.learnMoreItem?.type ===
                        ("MODAL" as AnnouncementLearnMoreEnum)
                          ? learnMoreModalHandler?.(item)
                          : item.videoUrl &&
                            window.open(
                              item.videoUrl,
                              item.learnMoreItem?.enabledNewWindow
                                ? "_blank"
                                : "_self"
                            )
                      }}
                    >
                      Learn More
                    </Button>
                  )}
                </Stack>

                {item.type === "TIP" && (
                  <Box>
                    {item.resources && item.resources?.length > 0 && (
                      <Typography variant="h4">Help Articles</Typography>
                    )}
                    {item.resources?.map((resource, index) => {
                      return (
                        <Link
                          key={resource.name}
                          href={resource.url}
                          target="_blank"
                          variant="h5"
                        >
                          {resource?.name || ""}
                        </Link>
                      )
                    })}
                  </Box>
                )}
              </Box>
            </Fragment>
          )
      )}
    </>
  )
}

export default GhostieContent
